<template>
	<div class="summary sticky" :style="'--accent:' + this.accent" v-if="summary_data !=null">
		<p class="heading">
			Your Quote
			<i class="fas fa-chevron-down"></i>
		</p>
		<div class="summary_details">
			<template v-if="this.summary_data != null && (Object.keys(this.summary_data.accommodation).length > 0) || Object.keys(this.summary_data.activities).length > 0">
				<ul class="level_1">
					<li v-if="this.summary_data != null && Object.keys(this.summary_data.accommodation).length > 0">
						Your Accommodation
						<ul class="level_2">
							<li v-for="item in summary_data.accommodation">
								{{ item.activity_name }} {{ item.option_name }} <button class="remove"><i class="fas fa-minus-circle" v-on:click="removeActivity(item.activity_id)"></i></button>
							</li>
						</ul>
					</li>
					<li v-if="this.summary_data != null && Object.keys(this.summary_data.activities).length > 0">
						Your Activities
						<ul class="level_2">
							<li v-for="item in summary_data.activities">
								{{ item.activity_name }} {{ item.option_name }} <button class="remove"><i class="fas fa-minus-circle" v-on:click="removeActivity(item.activity_id)"></i></button>
							</li>
						</ul>
					</li>
				</ul>
				<button type="button" class="button medium solid wide" v-on:click="toggleQuoteForm()">Get a quote</button>
			</template>
			<template v-else>
				<p>Please choose some activities</p>
			</template>
		</div>
	</div>
	<div class="summary loading sticky" :style="'--accent:' + this.accent" v-else>
		<i class="fas fa-spinner fa-spin"></i>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'accent',
		'destination_id',
	],

	data: () => {
		return {
			summary_data: null
		}
	},

	computed: {
		items () {
			return this.$store.getters.getItem(this.destination_id, 'destination');
		}
	},

	watch: {
		items: function(value) {
			this.getBuildYourOwnInfo();
		}
	},

	created() {
	},

	mounted() {
		this.getBuildYourOwnInfo();
	},

	methods: {
		getBuildYourOwnInfo: function(){
			// return null;
			axios.post('/ajax/getBuildYourOwnInfo', {
				destination_id: parseInt(this.destination_id),
				basket: this.items
			})
			.then(response => {
				this.summary_data = response.data
			})
			.catch(error => {
				console.log(error);
			});
		},

		removeActivity: function(activity_id){
			this.$store.commit({
				type: 'removeActivityFromStore',
				store_type: 'destination',
				store_id: parseInt(this.destination_id),
				activity_id: parseInt(activity_id),
			});
		},

		toggleQuoteForm: function(){
			this.$root.$refs.quoteform.toggleQuoteForm();
		}
	}
};
</script>